module.exports = __webpack_public_path__ + "static/media/gaming.255f4f41.jpg";